/**
 * Cart urgency timer (Dawn)
 *
 * - One shared timer (length set in the theme editor), started when the cart first gets an item.
 * - Every banner (cart page + drawer, every line item) reads the same start time,
 *   so items added later show the remaining time, not a fresh countdown.
 * - When it runs out, banners show the static "Limited quantities…" text.
 * - If the cart is emptied, a fresh timer only starts when an item is added
 *   the configured number of hours after the previous timer started.
 * - Survives reloads and syncs across tabs (localStorage).
 */
(function () {
  if (window.CartUrgency) return;

  var KEY = 'cart_urgency_v1';
  // Values come from Theme settings > Cart urgency timer (set in theme.liquid)
  var cfg = window.cartUrgencySettings || {};
  var DURATION = (Number(cfg.minutes) || 15) * 60 * 1000;
  var RESET_AFTER = (Number(cfg.resetHours) || 24) * 60 * 60 * 1000;
  var SELECTOR = '[data-cart-urgency]';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }

  function write(state) {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  /** Update stored state from the current cart item count. */
  function sync(count) {
    var s = read();
    var now = Date.now();

    if (count > 0) {
      var firstTime = !s.start;
      var refillAfter24h = s.emptied && now - s.start >= RESET_AFTER;
      if (firstTime || refillAfter24h) s.start = now;
      s.emptied = false;
    } else if (s.start) {
      s.emptied = true;
    }

    write(s);
  }

  function format(ms) {
    var total = Math.ceil(ms / 1000);
    var m = Math.floor(total / 60);
    var sec = total % 60;
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  function render() {
    var banners = document.querySelectorAll(SELECTOR);
    if (!banners.length) return;

    // A banner on screen means the cart has items, even if we haven't
    // heard about it yet (e.g. drawer just re-rendered after an add).
    var s = read();
    if (!s.start || s.emptied) {
      sync(1);
      s = read();
    }

    var left = s.start + DURATION - Date.now();

    banners.forEach(function (el) {
      var msg = left > 0
        ? el.dataset.timerText.replace('{timer}', format(left))
        : el.dataset.expiredText;
      var target = el.querySelector('.cart-urgency__text') || el;
      if (target.textContent !== msg) target.textContent = msg;
      el.classList.toggle('is-expired', left <= 0);
      el.classList.remove('is-pending');
    });
  }

  function refreshFromCart() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { sync(cart.item_count); render(); })
      .catch(function () {});
  }

  // Render as soon as Dawn swaps in new cart HTML (drawer / cart page)
  var queued = false;
  function queueRender() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; render(); });
  }

  function init() {
    if (typeof window.cartUrgencyInitialCount === 'number') {
      sync(window.cartUrgencyInitialCount);
    }
    render();
    setInterval(render, 1000);

    new MutationObserver(queueRender).observe(document.body, { childList: true, subtree: true });

    // Dawn 9+ publishes cart changes (add, quantity change, remove)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshFromCart);
    }

    // Keep multiple open tabs in sync
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) render();
    });
  }

  window.CartUrgency = { render: render, refresh: refreshFromCart };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
